import { createElement } from "react";
import { IRouteConfig } from "../../../helpers/route-config";
import { TakeFiveHome } from "./takeFiveHome";
import { TakeFiveSectionTakeFive } from "./TakeFiveSectionTakeFive";
import { TakeFiveSection } from "./TakeFiveSection";
import { TakeFiveSectionOverview } from "./TakeFiveSectionOverview";
import TakeFiveDetails from "./TakeFiveDetails";

// Pages
export const takeFivePath = "/takefive";

export const overview = 'takefiveoverview';

//Take 5
const takeFiveSectionPath = `${takeFivePath}/takefivesection`;
const takeFiveOverviewPath = `${takeFivePath}/${overview}`;
const takeFiveFormPath = `${takeFivePath}/takefive`;
const takeFiveDetailsPath = `${takeFivePath}/:dashboardType/:id/:tab?`;

export const takeFiveRoute = {
    breadCrumb: "Digital Take 5",
    path: takeFivePath,
    element: createElement(TakeFiveHome)
} as IRouteConfig;

export const takeFiveSectionPathRoute = {
    breadCrumb: "Take 5 Section",
    path: takeFiveSectionPath,
    element: createElement(TakeFiveSection)
} as IRouteConfig;

export const takeFiveOverviewPathRoute = {
    breadCrumb: "Overview",
    path: takeFiveOverviewPath,
    element: createElement(TakeFiveSectionOverview),
} as IRouteConfig;

export const takeFivePathRoute = {
    breadCrumb: "Take 5 Form",
    path: takeFiveFormPath,
    element: createElement(TakeFiveSectionTakeFive),
} as IRouteConfig;

export const takeFiveDetailsPathRoute = {
    breadCrumb: "Details",
    path: takeFiveDetailsPath,
    element: createElement(TakeFiveDetails),
} as IRouteConfig;
